import React from 'react';
import PropTypes from 'prop-types';
const propTypes = {
  /**
   * Date the data was pulled
   **/
  asOfDate: PropTypes.string,
  /**
   * Identifier for automated tests added to the `data-qa` HTML attribute
   **/
  qaId: PropTypes.string,
  /**
   * Description of data point
   **/
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Data point
   **/
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
const defaultProps = {
  asOfDate: '',
  qaId: '',
  title: '',
  value: ''
};
function DataCard(props) {
  let {
    title,
    value,
    asOfDate,
    qaId
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-card asc-card--data asc-card--formatted",
    "data-qa": qaId
  }, /*#__PURE__*/React.createElement("p", {
    className: "asc-card-title"
  }, title, asOfDate && /*#__PURE__*/React.createElement("span", null, "as of ", asOfDate)), /*#__PURE__*/React.createElement("p", {
    className: "asc-card-value"
  }, value));
}
DataCard.propTypes = propTypes;
DataCard.defaultProps = defaultProps;
export default DataCard;